export const storeIdDescriptions = {
  postpaid: {
    MSISDN: {
      title: "Store ID for Postpaid MSISDN",
      description: "Store ID for Mobile Subscriber ISDN Number allocation. Used for activating postpaid mobile subscriptions.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    },
    eSIM: {
      title: "Store ID for Postpaid eSIM",
      description: "Store ID for eSIM. No physical SIM card, but a digital version of a SIM built into a device.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    },
    "Blank Sim": {
      title: "Store ID for Postpaid Blank Sim",
      description: "Store ID for Blank Sim allocation. Unassigned physical SIM card used for testing networks without a specific number.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    }
  },
  prepaid: {
    MSISDN: {
      title: "Store ID for Prepaid MSISDN",
      description: "Store ID for prepaid mobile number allocation. Used to identify the distribution channel for mobile number assignment.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    },
    "Blank Sim": {
      title: "Store ID for Prepaid Blank SIM",
      description: "Store ID for prepaid blank SIM allocation. Used to track distribution of unassigned SIM cards for testing purposes.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    },
    "RM5": {
      title: "Store ID for Prepaid RM5",
      description: "Store ID is required for RM5 starter pack. Used to identify the distribution channel for the starter pack.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    },
    "RM10": {
      title: "Store ID for Prepaid RM10",
      description: "Store ID is required for RM10 starter pack. Used to identify the distribution channel for the starter pack.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    },
    "RM20": {
      title: "Store ID for Prepaid RM20",
      description: "Store ID is required for RM20 starter pack. Used to identify the distribution channel for the starter pack.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    },
    "RM30": {
      title: "Store ID for Prepaid RM30",
      description: "Store ID is required for RM30 starter pack. Used to identify the distribution channel for the starter pack.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    },
    "RM50": {
      title: "Store ID for Prepaid RM50",
      description: "Store ID is required for RM50 starter pack. Used to identify the distribution channel for the starter pack.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    },
    "RM100": {
      title: "Store ID for Prepaid RM100",
      description: "Store ID is required for RM100 starter pack. Used to identify the distribution channel for the starter pack.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    },
    "Others": {
      title: "Store ID for Prepaid Others",
      description: "Store ID is required for this item. Used to identify the distribution channel.",
      examples: ["Blue Cube: CKL89999- Prod / BCC10000KUL- Testbed", "Dealer: CKL89998- Prod / SWK50034- Testbed", "Enterprise: 99974 (Both Prod & Testbed)", "E-Store: CKL47948 (Both Prod & Testbed)",
      "Or Ask TDS in the chat area: Give examples for store id"]
    },
    "Reload_RM5": {
      title: "Store ID for Reload RM5",
      description: "Store ID field is not required for Reload items in this environment. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    },
    "Reload_RM10": {
      title: "Store ID for Reload RM10",
      description: "Store ID field is not required for Reload items in this environment. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    },
    "Reload_RM30": {
      title: "Store ID for Reload RM30",
      description: "Store ID field is not required for Reload items in this environment. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    },
    "Reload_RM50": {
      title: "Store ID for Reload RM50",
      description: "Store ID field is not required for Reload items in this environment. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    },
    "Reload_RM100": {
      title: "Store ID for Reload RM100",
      description: "Store ID field is not required for Reload items in this environment. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    },
    "Softpin_RM5": {
      title: "Store ID for Softpin RM5",
      description: "Store ID field is not required for Softpin items in this environment. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    },
    "Softpin_RM10": {
      title: "Store ID for Softpin RM10",
      description: "Store ID field is not required for Softpin items in this environment. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    },
    "Softpin_RM20": {
      title: "Store ID for Softpin RM20",
      description: "Store ID field is not required for Softpin items in this environment. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    },
    "Softpin_RM30": {
      title: "Store ID for Softpin RM30",
      description: "Store ID field is not required for Softpin items in this environment. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    },
    "Softpin_RM50": {
      title: "Store ID for Softpin RM50",
      description: "Store ID field is not required for Softpin items in this environment. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    },
    "Softpin_RM100": {
      title: "Store ID for Softpin RM100",
      description: "Store ID field is not required for Softpin items in this environment. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    }
  }
};

export const materialCodeDescriptions = {
  postpaid: {
    eSIM: {
      title: "Material Code for eSIM",
      description: "The material code is an essential part of the information required when filling out test data request forms.",
      examples: ["ESIM030001- (SIM CARD-ESIM POST-GHUDC-64K ESIM)"]
    },
    "Blank Sim": {
      title: "Material Code for Blank SIM",
      description: "The material code is an essential part of the information required when filling out test data request forms.",
      examples: ["20012802- (SIM CARD-UNIVERSAL 5G-GHUDC-HALF SIZE)", "20015621- (SIM CARD-UNIVERSAL-BLANK SIM-64K 3IN1)", "20009721- (SIM CARD-POSTPAID-GHUDC-64K USIM 3 IN 1)", 
        "20012352- (SIM CARD-UNIVERSAL-GHUDC-HALF SIZE)", "Or Ask TDS in the chat area: Give examples for material code"]
    }
  },
  prepaid: {
    "MSISDN": {
      title: "Material Code for Prepaid MSISDN",
      description: "Not required to fill in. This field is automatically disabled.",
      examples: ["Not applicable - field is disabled"]
    },
    "Blank Sim": {
      title: "Material Code for Prepaid Blank SIM",
      description: "Product code for prepaid blank SIM cards. Identifies the specific type of blank SIM card being requested.",
      examples: ["20012802- (SIM CARD-UNIVERSAL 5G-GHUDC-HALF SIZE)", "20015621- (SIM CARD-UNIVERSAL-BLANK SIM-64K 3IN1)", 
        "20012352- (SIM CARD-UNIVERSAL-GHUDC-HALF SIZE)", "20015387- (SIM CARD-GENERIC-LIGHTNING-64K 3IN1)", 
        "Or Ask TDS in the chat area: Give examples for material code"]
    },
    "Starter Pack_RM5": {
      title: "Material Code for Prepaid Starter Pack RM5",
      description: "Product code for RM5 prepaid starter pack item. Enter the appropriate material code for this denomination.",
      examples: ["20015520- (SPACK-CD PREPAID RM5-5G-BIRU)", "20013225- (SPACK-CXPAX RM5-CTRL1)", 
        "Or Ask TDS in the chat area: Give examples for material code"]
    },
    "Starter Pack_RM10": {
      title: "Material Code for Prepaid Starter Pack RM10",
      description: "Product code for RM10 prepaid starter pack item. Enter the appropriate material code for this denomination.",
      examples: ["20015622- (SPACK-CD PREPAID RM10 MODENTRADE-5G-BIRU)", "20015519- (SPACK-CD PREPAID RM10-5G-BIRU)", 
        "20013188- (SPACK-CXPAX RM10-CTRL1)", "Or Ask TDS in the chat area: Give examples for material code"]
    },
    "Starter Pack_RM30": {
      title: "Material Code for Prepaid Starter Pack RM30",
      description: "Product code for RM30 prepaid starter pack item. Enter the appropriate material code for this denomination.",
      examples: ["20011545- (SPACK-XPAX2019 RM30-CTRL1)"]
    },
    "Starter Pack_RM50": {
      title: "Material Code for Prepaid Starter Pack RM50",
      description: "Product code for RM50 prepaid starter pack item. Enter the appropriate material code for this denomination.",
      examples: ["SP-RM50-001", "SP-RM50-002"]
    },
    "Others": {
      title: "Material Code for Prepaid Starter Pack Others",
      description: "Insert a unique material code for \"other\" prepaid items. Enter the appropriate material code for this item.",
      examples: ["OTHER-001", "OTHER-002"]
    },
    "Reload_RM5": {
      title: "Material Code for Reload RM5",
      description: "Product code for Reload RM5. Enter the appropriate material code for this reload denomination.",
      examples: ["20009618- (Celcom RC 5)"]
    },
    "Reload_RM10": {
      title: "Material Code for Reload RM10",
      description: "Product code for Reload RM10. Enter the appropriate material code for this reload denomination.",
      examples: ["20009620- (Celcom RC 10)"]
    },
    "Reload_RM30": {
      title: "Material Code for Reload RM30",
      description: "Product code for Reload RM30. Enter the appropriate material code for this reload denomination.",
      examples: ["20013827- (Celcom RC 30)"]
    },
    "Reload_RM50": {
      title: "Material Code for Reload RM50",
      description: "Product code for Reload RM50. Enter the appropriate material code for this reload denomination.",
      examples: ["20013828- (Celcom RC 50)"]
    },
    "Softpin_RM5": {
      title: "Material Code for Softpin RM5",
      description: "Product code for Softpin RM5. Enter the appropriate material code for this softpin denomination.",
      examples: ["ITM-00037- (RCARD-RM 5-SOFTPIN-GST B)"]
    },
    "Softpin_RM10": {
      title: "Material Code for Softpin RM10",
      description: "Product code for Softpin RM10. Enter the appropriate material code for this softpin denomination.",
      examples: ["ITM-00038- (RCARD-RM 10-SOFTPIN-GST B)"]
    },
    "Softpin_RM20": {
      title: "Material Code for Softpin RM20",
      description: "Product code for Softpin RM20. Enter the appropriate material code for this softpin denomination.",
      examples: ["ITM-00039- (RCARD-RM 20-SOFTPIN-GST B)"]
    },
    "Softpin_RM30": {
      title: "Material Code for Softpin RM30",
      description: "Product code for Softpin RM30. Enter the appropriate material code for this softpin denomination.",
      examples: ["ITM-00040- (RCARD-RM 30-SOFTPIN-GST B)"]
    },
    "Softpin_RM50": {
      title: "Material Code for Softpin RM50",
      description: "Product code for Softpin RM50. Enter the appropriate material code for this softpin denomination.",
      examples: ["ITM-00041- (RCARD-RM 50-SOFTPIN-GST B)"]
    },
    "Softpin_RM100": {
      title: "Material Code for Softpin RM100",
      description: "Product code for Softpin RM100. Enter the appropriate material code for this softpin denomination.",
      examples: ["ITM-00042- (RCARD-RM 100-SOFTPIN-GST B)"]
    }
  }
};

export const quantityDescriptions = {
  general: {
    title: "Quantity",
    description: "The number of items or services to be provisioned.",
    examples: ["1", "5", "10"]
  },
  postpaid: {
    MSISDN: {
      title: "MSISDN Quantity",
      description: "Number of mobile numbers to provision for postpaid service.",
      examples: ["1", "5", "10"]
    },
    eSIM: {
      title: "eSIM Quantity",
      description: "Number of eSIM profiles to provision for postpaid service.",
      examples: ["1", "2", "5"]
    },
    VOBB: {
      title: "VOBB Quantity",
      description: "Number of fixed-line numbers to provision for broadband service. Minimum quantity must be start from 10.",
      examples: ["10", "20", "50"]
    },
    "Blank Sim": {
      title: "Blank SIM Quantity",
      description: "Number of physical SIM cards to be allocated.",
      examples: ["1", "5", "10"]
    }
  },
  prepaid: {
    "Prepaid SIM": {
      title: "Prepaid SIM Quantity",
      description: "Number of prepaid SIM cards to be allocated. Specify the total count needed for testing.",
      examples: ["1", "5", "10"]
    },
    "Prepaid eSIM": {
      title: "Prepaid eSIM Quantity",
      description: "Number of prepaid eSIM profiles to be allocated. Specify the total count needed for testing.",
      examples: ["1", "2", "5"]
    },
    "MSISDN": {
      title: "MSISDN Quantity",
      description: "Number of prepaid mobile numbers to provision. Specify the total count needed.",
      examples: ["1", "5", "10"]
    },
    "Blank Sim": {
      title: "Blank SIM Quantity",
      description: "Number of prepaid blank SIM cards to be allocated. Specify the total count needed for testing.",
      examples: ["1", "5", "10"]
    }
  }
};

// Region field descriptions
export const regionDescriptions = {
  postpaid: {
    VOBB: {
      title: "Region for VOBB",
      description: "Select region for VOBB service location. Exchange area and charge area will be auto-filled when you select a region. You can also select exchange area or charge area to auto-fill other fields.",
      examples: ["CENTRAL", "NORTHERN", "SOUTHERN", "EASTERN", "SABAH", "SARAWAK"]
    }
  }
};

// Exchange Area field descriptions
export const exchangeAreaDescriptions = {
  postpaid: {
    VOBB: {
      title: "Exchange Area for VOBB",
      description: "Select exchange area for VOBB service location. Region and charge area will be auto-filled when you select an exchange area. Also auto-fills when region or charge area is selected.",
      examples: ["KUALA LUMPUR", "PETALING", "JOHOR BAHRU", "IPOH", "KUCHING"]
    }
  }
};

// Charge Area field descriptions
export const chargeAreaDescriptions = {
  postpaid: {
    VOBB: {
      title: "Charge Area for VOBB",
      description: "Select charge area for VOBB service location. Region and exchange area will be auto-filled when you select a charge area. Also auto-fills when region or exchange area is selected.",
      examples: ["KUALA LUMPUR", "PETALING", "JOHOR BAHRU", "CHERAS", "PENANG"]
    }
  }
};